import { DateRangeFormat } from '@intentsify/types';
import { DateTime, Interval, Settings } from 'luxon';
Settings.defaultLocale = 'en-US';
export const formatDateRange = (range, format = DateRangeFormat.StartEndDateMonth) => {
    const startDate = DateTime.fromISO(range.start, { zone: 'utc' });
    const endDate = DateTime.fromISO(range.end, { zone: 'utc' });
    switch (true) {
        case format === DateRangeFormat.Dates: {
            const start = startDate.toISODate();
            const end = endDate.toISODate();
            return `${start} — ${end}`;
        }
        case format === DateRangeFormat.StartDate: {
            const start = startDate.toISODate();
            return start;
        }
        case format === DateRangeFormat.StartDateMonth: {
            const start = startDate.toFormat('DD');
            return start;
        }
        case format === DateRangeFormat.StartEndDateMonth: {
            const start = startDate.toFormat('DD');
            const end = endDate.toFormat('DD');
            return `${start} — ${end}`;
        }
        case format === DateRangeFormat.StartEndDateMonthDash: {
            const start = startDate.toFormat('DD');
            const end = endDate.toFormat('DD');
            return `${start}_${end}`.replace(/\s/g, '-').replace(/,/g, '');
        }
        case format === DateRangeFormat.WeekNumber: {
            const interval = Interval.fromDateTimes(startDate, endDate);
            const weeks = interval.splitBy({ weeks: 1 });
            return `Week ${weeks.map((w) => w.start.weekNumber).join(', ')}`;
        }
        case format === DateRangeFormat.Month: {
            const interval = Interval.fromDateTimes(startDate, endDate);
            const weeks = interval.splitBy({ weeks: 1 });
            return `${weeks
                .map((w) => {
                const months = Array.from(new Set([w.start.monthShort, w.end.monthShort])).join(' / ');
                return months;
            })
                .join(', ')}`;
        }
    }
    return `${range.start} - ${range.end}`;
};
//# sourceMappingURL=formatDateRange.js.map